const paymentEnterpriseEligibilityUrl = "v1/credit/billing/payments/eligibility";
export {
  paymentEnterpriseEligibilityUrl
};
//# sourceMappingURL=endpoints.js.map
